import { Box, Card, HStack, Skeleton, SkeletonText, VStack } from '@chakra-ui/react';

export const RafflePrizeCardSkeleton = () => (
  <>
    <Card.Root w="full" hideFrom="md">
      <Card.Body p={6}>
        <VStack alignItems="start" gap={4}>
          <HStack gap={4}>
            <Skeleton w="90px" h="90px" borderRadius="16px" />
            <Skeleton height="24px" width="60px" />
          </HStack>
          <VStack alignItems="start" gap={3} w="full">
            <HStack justifyContent="space-between" w="full">
              <Skeleton height="20px" width="40px" />
              <Skeleton height="24px" width="80px" />
            </HStack>
            <HStack justifyContent="space-between" w="full">
              <Skeleton height="20px" width="60px" />
              <Skeleton height="24px" width="60px" />
            </HStack>
            <HStack justifyContent="space-between" w="full">
              <Skeleton height="20px" width="100px" />
              <Skeleton height="24px" width="60px" />
            </HStack>
            <HStack justifyContent="space-between" w="full">
              <Skeleton height="20px" width="80px" />
              <Skeleton height="24px" width="100px" />
            </HStack>
          </VStack>
        </VStack>
      </Card.Body>
    </Card.Root>

    <Card.Root w="full" hideBelow="md">
      <HStack h="full" gap={0}>
        {/* Image placeholder */}
        <Skeleton boxSize="226px" />

        <VStack alignSelf="stretch" w="full">
          {/* Top row: Title, description & modal placeholder */}
          <HStack
            alignSelf="stretch"
            justifyContent="space-between"
            bg="bg"
            flex="1"
            padding={6}
            borderBottom="1px solid #F0F0F0"
          >
            <Box>
              <Skeleton height="24px" width="80%" mb={2} />
              <SkeletonText noOfLines={2} gap={2} width={['100%', '100%', '80%']} />
            </Box>
            {/* Placeholder for AddTicketsModal */}
            <Skeleton height="40px" width="40px" borderRadius="md" />
          </HStack>

          {/* Bottom row: Raffle stats and badge */}
          <HStack alignSelf="stretch" justifyContent="space-between" flex="1" padding={6}>
            <HStack flex="1" justifyContent="start" gap={4}>
              {/* Each RaffleStat is replaced with a skeleton */}
              <Skeleton height="20px" width="60px" />
              <Skeleton height="20px" width="60px" />
              <Skeleton height="20px" width="60px" />
              {/* Optionally, include one more if "Ending in" stat is expected */}
              <Skeleton height="20px" width="80px" />
            </HStack>
            {/* Placeholder for the badge */}
            <Skeleton height="30px" width="100px" borderRadius="md" />
          </HStack>
        </VStack>
      </HStack>
    </Card.Root>
  </>
);
